import type { Timesheet, TimesheetOvertime, TimesheetOvertimeInput } from '../types';

export const monthBounds = (month: string) => {
  const [year, number] = month.split('-').map(Number) as [number, number];
  return { from: `${month}-01`, to: `${month}-${new Date(year, number, 0).getDate()}` };
};

export const missionMonthBounds = (timesheet: Timesheet) => {
  const month = monthBounds(timesheet.periodMonth);
  return {
    from: timesheet.mission.startDate > month.from ? timesheet.mission.startDate : month.from,
    to:
      timesheet.mission.endDate && timesheet.mission.endDate < month.to
        ? timesheet.mission.endDate
        : month.to,
  };
};

export const overtimeInput = (entry: TimesheetOvertime): TimesheetOvertimeInput => ({
  date: entry.date,
  startTime: entry.startTime,
  endTime: entry.endTime,
  typeId: entry.type?.id ?? null,
  surchargeRate: entry.surchargeRate,
  motive: entry.motive,
});

export const extraDate = (date: string) =>
  new Date(`${date}T12:00:00`).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
